// assets/recommended-cart.js
(function(){
  document.addEventListener('DOMContentLoaded', () => {
    const blocks = document.querySelectorAll('.product__block__recommended');
    if (!blocks.length) return;

    blocks.forEach(block => {
      const checkbox = block.querySelector('input[name="recommended_add"]');
      if (!checkbox) return;

      const variantId = parseInt(checkbox.value, 10);

      checkbox.addEventListener('change', function(){
        if (!this.checked) return;

        // 1) Add to cart via AJAX
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
        .then(r => r.json())
        .then(item => {
          // 2) Refresh header/drawer totals
          return fetch('/cart.js')
            .then(r => r.json())
            .then(cart => {
              document.dispatchEvent(new CustomEvent('theme:cart:change', {
                detail: { cart },
                bubbles: true
              }));

              // 3) Trigger your popdown with the variant ID
              document.dispatchEvent(new CustomEvent('theme:cart:popdown', {
                detail: { variant: { id: variantId } },
                bubbles: true
              }));
            });
        })
        .catch(err => {
          console.error('❌ Add error:', err);
          //alert(err.message || 'Could not add to cart');
          this.checked = false;
        });
      });
    });
  });
})();
